import { useContext, useState } from "react";
import { SelectableTextContext } from "../../../../contexts";
import TextPartComponent from "./TextPartComponent";
import TextChoiceComponent from "./TextChoiceComponent";
import * as Constants from "../../../../utils/constants"
import { Disclosure } from '@headlessui/react'
import { MagnifyingGlassIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

let defaultFilter = {
    search: "",
    keywords: []
};

export default function SelectableTextComponent({ inSidebarDialog }) {
    const { selectableTexts, keywords } = useContext(SelectableTextContext);
    const { t: te } = useTranslation([resources.edit]);

    const [filter, setFilter] = useState({
        search: "",
        keywords: keywords
    });

    const handleSearch = (event) => {
        setFilter({
            search: event.target.value, 
            keywords: filter.keywords
        });
    }

    const handleKeywords = (keyword) => {
        let newKeywords = filter.keywords;

        if (newKeywords.includes(keyword)) {
            newKeywords = newKeywords.filter(k => k !== keyword);
        } else {
            newKeywords.push(keyword);
        }

        setFilter({
            search: filter.search,
            keywords: newKeywords
        });
    }

    return (
        <div className="tw-h-full tw-w-full tw-flex tw-flex-col">
            <Disclosure>
                {({ open }) => (
                    <div className={open ? "tw-border tw-rounded-md tw-shadow-sm tw-mb-5" : ""}>
                        <Disclosure.Button className="tw-flex tw-w-full tw-justify-between tw-px-4 tw-py-2 tw-text-left tw-mb-2">
                            <span>{te(translations.edit.predefined.filter)}</span>
                            <ChevronUpIcon
                                style={{ fill: 'none' }}
                                className={`${open ? 'tw-rotate-180 tw-transform' : ''
                                    } tw-h-5 tw-w-5`}
                            />
                        </Disclosure.Button>
                        <Disclosure.Panel className="tw-text-gray-700 tw-mb-2 tw-py-2 tw-px-5">
                            <>
                                <div className="tw-flex tw-justify-start tw-mb-4 tw-relative tw-rounded-md tw-mr-6 tw-w-full">
                                    <MagnifyingGlassIcon className="tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-h-5 tw-m-auto tw-mx-2 tw-text-gray-400 tw-ml-3" />
                                    <input
                                        aria-label={te(translations.edit.search)}
                                        type={"text"}
                                        // value={searchBy}
                                        className={`focus:tw-ring-transparent tw-w-full focus:tw-border-gray-300 tw-block sm:tw-text-sm tw-border-gray-300 tw-rounded-md tw-pl-10`}
                                        onChange={handleSearch}
                                        placeholder={te(translations.edit.search)}
                                    />
                                </div>
                                <div className="tw-flex tw-flex-wrap tw-gap-2">
                                    {
                                        keywords?.map((keyword, index) => {
                                            return (
                                                <div key={index} className="tw-flex tw-items-center">
                                                    <input
                                                        id={`predefined-filter-${keyword}`}
                                                        type="checkbox"
                                                        className="focus:tw-ring-transparent tw-h-4 tw-w-4 tw-text-indigo-700 tw-border-gray-300 tw-rounded"
                                                        onChange={() => handleKeywords(keyword)}
                                                        checked={filter.keywords.includes(keyword)}
                                                    />
                                                    <label htmlFor={`predefined-filter-${keyword}`} className="tw-ml-2 tw-text-sm tw-break-all">{keyword}</label>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        </Disclosure.Panel>
                    </div>
                )}
            </Disclosure>

            <div className="tw-space-y-3 sm:tw-space-y-5 tw-mt-2">
                {selectableTexts && selectableTexts.map((editorBaseModel) => (
                    <div key={editorBaseModel.Id}>
                        {
                            (editorBaseModel.Type === Constants.editorType.textPart)
                                ?
                                (
                                    <TextPartComponent filter={filter} editorTextPart={editorBaseModel} inSidebarDialog={inSidebarDialog}></TextPartComponent>
                                )
                                :
                                (
                                    <TextChoiceComponent filter={filter} editorTextChoice={editorBaseModel} inSidebarDialog={inSidebarDialog}></TextChoiceComponent>
                                )
                        }
                    </div>
                ))}
            </div>
        </div>
    )

}